import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";

import "./CopyToClipboard";

@customElement("ds-place-id")
export class PlaceId extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: inline;
            }

            .container {
                display: flex;
                align-items: center;
            }

            .container span,
            .container ds-copy-to-clipboard {
                color: black;
                font-variant: all-petite-caps;
            }
        `,
    ];
    @property({ type: String }) placeId?: string;

    override render() {
        return html`<div class="container">
            <span>${this.placeId ?? ""}</span>
            <ds-copy-to-clipboard .text=${this.placeId ?? ""}></ds-copy-to-clipboard>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-place-id": PlaceId;
    }
}
